import { createReducer, on } from '@ngrx/store';

import { BaseActionState } from '@ptg-shared/types/models';

import {
  checkMemberGeneratingDocumentAction,
  checkMemberGeneratingDocumentFailureAction,
  checkMemberGeneratingDocumentSuccessAction,
  clearCheckMemberGeneratingDocumentAction,
  clearEditDocumentsStateAction,
  clearGetDocumentListsStateAction,
  clearGetOrganizationDocumentListsStateAction,
  clearNavigateToDocumentListsAction,
  clearRemoveDocumentsStateAction,
  clearRemoveOrganizationDocumentsStateAction,
  clearUploadDocumentsStateAction,
  clearUploadOrganizationDocumentsStateAction,
  editDocumentsAction,
  editDocumentsFailureAction,
  editDocumentsSuccessAction,
  getDocumentListsAction,
  getDocumentListsFailureAction,
  getDocumentListsSuccessAction,
  getOrganizationDocumentListsAction,
  getOrganizationDocumentListsFailureAction,
  getOrganizationDocumentListsSuccessAction,
  navigateToDocumentListsAction,
  removeDocumentsAction,
  removeDocumentsFailureAction,
  removeDocumentsSuccessAction,
  removeOrganizationDocumentsAction,
  removeOrganizationDocumentsFailureAction,
  removeOrganizationDocumentsSuccessAction,
  uploadDocumentsAction,
  uploadDocumentsFailureAction,
  uploadDocumentsSuccessAction,
  uploadOrganizationDocumentsAction,
  uploadOrganizationDocumentsFailureAction,
  uploadOrganizationDocumentsSuccessAction,
} from '../actions/member-document.action';
import { DocumentList } from '@ptg-member/types/models/member-document.model';
import { ACTION, ActionState, STATE } from '@ptg-shared/constance';
import { GetGeneratedReportsInformationResponse } from 'src/app/admin/features/file/services/models/documents.model';
import { clearActuayReportStateAction, getActuayReportAction, getActuayReportActionFailAction, getActuayReportActionSuccessAction } from '../actions/actuary-report.action';
import { GetActuaryReportInformationResponse } from '@ptg-member/types/models/actuary-report.model';

export const memberDocumentFeatureKey = 'memberDocument';
export interface DocumentListState {
  getDocumentLists?: BaseActionState<DocumentList[]>;
  getOrganizationDocumentLists?: BaseActionState<DocumentList[]>;
  removeOrganizationDocuments?: ActionState;
  uploadOrganizationDocuments?: ActionState;
  removeDocuments?: ActionState;
  uploadDocuments?: ActionState;
  editDocuments?: ActionState;
  checkGeneratingDocument?: BaseActionState<GetGeneratedReportsInformationResponse>;
  getNavigateToDocumentListWithGenerateId?: string;
  getActuaryReport?: BaseActionState<GetActuaryReportInformationResponse>
}

const initialState: DocumentListState = {};

export const documentListReducer = createReducer(
  initialState,

  on(getOrganizationDocumentListsAction, (state) => ({
    ...state,
    getOrganizationDocumentLists: {
      isLoading: true,
    },
  })),
  on(getOrganizationDocumentListsSuccessAction, (state, { response }) => ({
    ...state,
    getOrganizationDocumentLists: {
      isLoading: false,
      success: true,
      payload: response.organizationDocuments,
      total: response.total,
    },
  })),
  on(getOrganizationDocumentListsFailureAction, (state, { error }) => ({
    ...state,
    getOrganizationDocumentLists: {
      isLoading: false,
      success: false,
      error: error,
    },
  })),
  on(clearGetOrganizationDocumentListsStateAction, (state) => ({
    ...state,
    getOrganizationDocumentLists: undefined,
  })),

  // Remove Organization document
  on(removeOrganizationDocumentsAction, (state) => ({
    ...state,
    removeOrganizationDocuments: undefined,
  })),
  on(removeOrganizationDocumentsSuccessAction, (state) => ({
    ...state,
    removeOrganizationDocuments: {
      state: STATE.SUCCESS,
      action: ACTION.REMOVE,
    },
  })),
  on(removeOrganizationDocumentsFailureAction, (state, { error }) => ({
    ...state,
    removeOrganizationDocuments: {
      state: STATE.FAIL,
      action: ACTION.REMOVE,
    },
  })),
  on(clearRemoveOrganizationDocumentsStateAction, (state) => ({
    ...state,
    removeOrganizationDocuments: undefined,
  })),

  // Upload Document
  on(uploadOrganizationDocumentsAction, (state) => ({
    ...state,
    uploadOrganizationDocuments: {
      state: 'loading',
      action: ACTION.UPLOAD,
    },
  })),
  on(uploadOrganizationDocumentsSuccessAction, (state) => ({
    ...state,
    uploadOrganizationDocuments: {
      state: STATE.SUCCESS,
      action: ACTION.UPLOAD,
    },
  })),
  on(uploadOrganizationDocumentsFailureAction, (state, { error }) => ({
    ...state,
    uploadOrganizationDocuments: {
      state: STATE.FAIL,
      action: ACTION.UPLOAD,
    },
  })),
  on(clearUploadOrganizationDocumentsStateAction, (state) => ({
    ...state,
    uploadOrganizationDocuments: undefined,
  })),

  on(getDocumentListsAction, (state) => ({
    ...state,
    getDocumentLists: {
      isLoading: true,
    },
  })),
  on(getDocumentListsSuccessAction, (state, { response }) => ({
    ...state,
    getDocumentLists: {
      isLoading: false,
      success: true,
      payload: response.participantDocuments,
      total: response.total,
    },
  })),
  on(getDocumentListsFailureAction, (state, { error }) => ({
    ...state,
    getDocumentLists: {
      isLoading: false,
      success: false,
      error: error,
    },
  })),
  on(clearGetDocumentListsStateAction, (state) => ({
    ...state,
    getDocumentLists: undefined,
  })),

  // Remove document
  on(removeDocumentsAction, (state) => ({
    ...state,
    removeDocuments: undefined,
  })),
  on(removeDocumentsSuccessAction, (state) => ({
    ...state,
    removeDocuments: {
      state: STATE.SUCCESS,
      action: ACTION.REMOVE,
    },
  })),
  on(removeDocumentsFailureAction, (state, { error }) => ({
    ...state,
    removeDocuments: {
      state: STATE.FAIL,
      action: ACTION.REMOVE,
    },
  })),
  on(clearRemoveDocumentsStateAction, (state) => ({
    ...state,
    removeDocuments: undefined,
  })),

  // Upload Document
  on(uploadDocumentsAction, (state) => ({
    ...state,
    uploadDocuments: {
      state: 'loading',
      action: ACTION.UPLOAD,
    },
  })),
  on(uploadDocumentsSuccessAction, (state) => ({
    ...state,
    uploadDocuments: {
      state: STATE.SUCCESS,
      action: ACTION.UPLOAD,
    },
  })),
  on(uploadDocumentsFailureAction, (state, { error }) => ({
    ...state,
    uploadDocuments: {
      state: STATE.FAIL,
      action: ACTION.UPLOAD,
    },
  })),
  on(clearUploadDocumentsStateAction, (state) => ({
    ...state,
    uploadDocuments: undefined,
  })),

  //Edit document
  on(editDocumentsAction, (state) => ({
    ...state,
    editDocuments: undefined,
  })),
  on(editDocumentsSuccessAction, (state) => ({
    ...state,
    editDocuments: {
      state: STATE.SUCCESS,
      action: ACTION.UPLOAD,
    },
  })),
  on(editDocumentsFailureAction, (state, { error }) => ({
    ...state,
    editDocuments: {
      state: STATE.FAIL,
      action: ACTION.UPLOAD,
    },
  })),
  on(clearEditDocumentsStateAction, (state) => ({
    ...state,
    editDocuments: undefined,
  })),

  on(checkMemberGeneratingDocumentAction, (state) => ({
    ...state,
    checkGeneratingDocument: {
      isLoading: true,
    },
  })),
  on(checkMemberGeneratingDocumentSuccessAction, (state, { response }) => ({
    ...state,
    checkGeneratingDocument: {
      isLoading: false,
      success: true,
      payload: response
    },
  })),
  on(checkMemberGeneratingDocumentFailureAction, (state, { error }) => ({
    ...state,
    checkGeneratingDocument: {
      isLoading: false,
      success: false,
      error: error,
    },
  })),
  on(clearCheckMemberGeneratingDocumentAction, (state) => ({
    ...state,
    checkGeneratingDocument: undefined,
  })),

  on(navigateToDocumentListsAction, (state ,{ generateInformationId }) => ({
    ...state,
    getNavigateToDocumentListWithGenerateId: generateInformationId,
  })),
  on(clearNavigateToDocumentListsAction, (state) => ({
    ...state,
    getNavigateToDocumentListWithGenerateId: undefined,
  })),

  // Actuary Report
  on(getActuayReportAction, (state) => ({
    ...state,
    getActuaryReport: {
      isLoading: true,
    },
  })),
  on(getActuayReportActionSuccessAction, (state, { response }) => ({
    ...state,
    getActuaryReport: {
      isLoading: false,
      success: true,
      payload: response,
      total: response.total,
    },
  })),

  on(getActuayReportActionFailAction, (state, { error }) => ({
    ...state,
    getActuaryReport: {
      isLoading: false,
      success: false,
      error,
    },
  })),
  on(clearActuayReportStateAction, (state) => ({
    ...state,
    getActuaryReport: undefined,
  })),
);
